import { styled } from "../../theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  position: relative;

  .quiz-container {
    /* max-height: 87%; */
  }
  .question-title {
    font-size: 2em;
    margin-top: 1em;
    margin-bottom: 0.5em;
    max-width: 65%;
    font-weight: normal;
    color: white;
  }

  .question-instructions {
    margin-top: 0.5em;
    font-size: 1.4em;
    color: white;
    font-style: italic;
  }
  .question-content {
  }
  #question-validate-button.question-button-validate {
    background-color: ${({ theme }) => theme.color.secondary};
    text-transform: uppercase;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    }
  }
  .answer-checkbox {
    font-size: 1.4em;
    padding: 1em;
    border-width: 0.15em;
    color: ${({ theme }) => theme.color.secondary};
  }

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    .question-title {
      max-width: 100%;
      font-size: 1.5em;
      margin-top: 2em;
    }
    .question-instructions {
      font-size: 1em;
    }
    .question-answers-container {
      flex-direction: column;
      justify-content: flex-start;
    }
    .answer-container {
      width: 90%;
    }
    .answer-checkbox {
      padding: 1em;
      padding-right: 2em;
      text-align: center;
    }
  }
`;
export const QuizTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 1em;
  text-transform: uppercase;
  font-size: 1em;
  .title_level_2 {
    color: ${({ theme }) => theme.color.secondary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.secondary} solid;
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
    position: relative;
    font-size: 0.9em;
    padding-top: 5em;
    padding-bottom: 2em;
    max-width: 90%;
  }
`;
